import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faAngleDown } from '@fortawesome/pro-solid-svg-icons';

import { toggleMobileFilters } from "../store/actions/ui";
export class MobileFilterTopBar extends React.Component {
  static propTypes = {
    contactRoles: PropTypes.array.isRequired,
    selectedRoles: PropTypes.array.isRequired,
    tags: PropTypes.array.isRequired,
    onDisplayFilters: PropTypes.func.isRequired
  };

  render() {
    const { selectedRoles, contactRoles, tags, onDisplayFilters } = this.props;

    const appliedFilters = [];
    selectedRoles.forEach((selectedRole) => {
      const role = contactRoles.find(role => role.value === selectedRole);
      appliedFilters.push(role.label);
    });
    tags.forEach(tag => appliedFilters.push(tag));

    return (
      <div className="d-md-none">
        <div className="filters-row mobile-filters-row py-3 d-flex align-items-center justify-content-center border-bottom">
          {appliedFilters.length > 0 ?
            <button className="filters-text d-flex" onClick={onDisplayFilters}>
              <div className="filters-count px-1 me-1">{appliedFilters.length}</div>
              <strong>Filters:</strong>
              <span className="ps-1 text-truncate">{appliedFilters.join(", ")}</span>
            </button>
            : <button className="filters-text" onClick={onDisplayFilters}>
              <FontAwesomeIcon
                className="me-1"
                icon={faFilter}
              />
              Filters
              <FontAwesomeIcon
                className="ms-1"
                icon={faAngleDown}
              />
            </button>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  contactRoles: state.static.contactRoles,
  selectedRoles: state.query.roles,
  tags: state.query.tags
});

const mapDispatchToProps = {
  onDisplayFilters: toggleMobileFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileFilterTopBar);
